import { useState, useEffect } from "react";
import { Phone, MessageCircle, FileText } from "lucide-react";
import QuoteDialog from "@/components/QuoteDialog";

const WA = "919810012256";
const TEL = "+919810012256";
const WA_HREF = `https://wa.me/${WA}?text=${encodeURIComponent("Hi GMS, I would like to discuss my requirement.")}`;

export default function StickyActionBar() {
  const [visible, setVisible] = useState(false);
  const [quoteOpen, setQuoteOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Desktop: bottom-center pill */}
      <div
        className={`hidden md:flex fixed bottom-6 left-1/2 -translate-x-1/2 z-30 items-center gap-1 bg-white border border-[#E2E8F0] shadow-lg rounded-sm p-1 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}
        style={{ transition: "opacity 250ms ease-out, transform 250ms ease-out" }}
        data-testid="sticky-action-bar"
      >
        <button
          onClick={() => setQuoteOpen(true)}
          className="bg-[#007BFF] hover:bg-[#0056b3] text-white px-4 py-2.5 text-sm font-semibold rounded-sm inline-flex items-center gap-2 transition-colors"
          data-testid="sticky-quote"
        >
          <FileText className="w-4 h-4" strokeWidth={2} /> Request Quote
        </button>
        <a
          href={WA_HREF}
          target="_blank" rel="noreferrer"
          className="text-[#0F3D66] hover:bg-[#F5F7FA] px-4 py-2.5 text-sm font-semibold rounded-sm inline-flex items-center gap-2 transition-colors"
          data-testid="sticky-whatsapp"
        >
          <MessageCircle className="w-4 h-4 text-[#25D366]" strokeWidth={2} /> WhatsApp
        </a>
        <a
          href={`tel:${TEL}`}
          className="text-[#0F3D66] hover:bg-[#F5F7FA] px-4 py-2.5 text-sm font-semibold rounded-sm inline-flex items-center gap-2 transition-colors"
          data-testid="sticky-call"
        >
          <Phone className="w-4 h-4 text-[#007BFF]" strokeWidth={2} /> Call Now
        </a>
      </div>

      {/* Mobile: bottom action row */}
      <div
        className={`md:hidden fixed bottom-0 inset-x-0 z-30 bg-white border-t border-[#E2E8F0] grid grid-cols-3 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}
        style={{ transition: "opacity 250ms, transform 250ms" }}
        data-testid="sticky-mobile-bar"
      >
        <a href={`tel:${TEL}`} className="flex flex-col items-center justify-center py-2.5 text-[10px] font-semibold text-[#0F3D66] border-r border-[#E2E8F0]" data-testid="mobile-call">
          <Phone className="w-4 h-4 text-[#007BFF] mb-1" strokeWidth={2}/> Call
        </a>
        <a href={WA_HREF} target="_blank" rel="noreferrer" className="flex flex-col items-center justify-center py-2.5 text-[10px] font-semibold text-[#0F3D66] border-r border-[#E2E8F0]" data-testid="mobile-whatsapp">
          <MessageCircle className="w-4 h-4 text-[#25D366] mb-1" strokeWidth={2}/> WhatsApp
        </a>
        <button onClick={() => setQuoteOpen(true)} className="flex flex-col items-center justify-center py-2.5 text-[10px] font-semibold text-white bg-[#007BFF]" data-testid="mobile-quote">
          <FileText className="w-4 h-4 mb-1" strokeWidth={2}/> Quote
        </button>
      </div>

      <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} leadType="quote" />
    </>
  );
}
